import { render, staticRenderFns } from "./payIndex.vue?vue&type=template&id=253ca2fe&scoped=true&"
import script from "./payIndex.vue?vue&type=script&lang=js&"
export * from "./payIndex.vue?vue&type=script&lang=js&"
import style0 from "./payIndex.vue?vue&type=style&index=0&id=253ca2fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253ca2fe",
  null
  
)

export default component.exports